import type { Confidence, Item, Scores } from '@mas-flow/types';
import { ApiHttpError } from './client';

async function jsonFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, { credentials: 'include', ...init });
  if (!res.ok) {
    const payload = await res.json().catch(() => undefined);
    throw new ApiHttpError(res.status, payload as { error: string; detail?: string } | undefined);
  }
  return (await res.json()) as T;
}

export async function cast(itemId: string, body: { scores?: Partial<Scores>; confidence?: Confidence | null }): Promise<Item> {
  const { item } = await jsonFetch<{ item: Item }>(`/api/items/${encodeURIComponent(itemId)}/votes`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  return item;
}

export async function withdraw(itemId: string): Promise<Item> {
  const { item } = await jsonFetch<{ item: Item }>(`/api/items/${encodeURIComponent(itemId)}/votes`, {
    method: 'DELETE',
  });
  return item;
}
